module.exports = {
  SELLER_TYPES_VIS: [
    'car_dealer',
    'real_estate_agency',
  ],
};
